import getAxiosInstance from '../../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../../helpers/lrs_adapter'

export class TablaCamionesEntreBrutoYDestareService {
  static async getDataCamionesEntreBrutoYDestare () {
    const axios = getAxiosInstance()
    return axios.get(`consulta_cea_con_peso_listado?r=` +
      `{"orden": ["d:fecha_de_bruto"]}`)
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}
